import { CssBaseline, ThemeProvider } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { FC, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useLocation, useRoutes } from "react-router-dom";
import ReactGA from "react-ga4";
import routes from "./routes";
import { ukoTheme } from "./theme";
import { AutoPushNotification } from "./components/AutoPushNotification";
import useAuth from "hooks/useAuth";
require('dotenv').config()

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);

  return null;
}

const App: FC = () => {
  const allPages = useRoutes(routes);
  const { isAuthenticated } = useAuth();

  // App theme
  const appTheme = ukoTheme();

  // toaster options
  const toasterOptions = {
    style: {
      fontWeight: 500,
      fontFamily: "'Montserrat', sans-serif",
    },
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <Toaster toastOptions={toasterOptions} />
        <RouteTracker />
        {allPages}
        {/* Solicitar notificações automaticamente quando usuário estiver autenticado */}
        {isAuthenticated && <AutoPushNotification />}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
